import axios from "axios";

const sendMessageDB = async (msg) => {
  try {
    // Extract JWT token from cookies.
    // `.trim().startsWith("token=")` pins to the exact cookie name —
    // `.includes("token=")` would also match `refresh_token=`,
    // `g_csrf_token=`, `xsrf_token=`, etc. and overwrite the real JWT
    // when one of those sits after `token=` in document.cookie.
    const cookies = document.cookie.split(";");
    let jwtCookie = null;

    cookies.forEach((cookie) => {
      const c = cookie.trim();
      if (c.startsWith("token=")) {
        jwtCookie = "Bearer " + c.slice("token=".length);
      }
    });

    if (!jwtCookie) {
      throw new Error("Authentication token is missing.");
    }

    // Send the request using axios
    const response = await axios.post(
      `${process.env.NEXT_PUBLIC_BASE_URL}/messages/create`,
      msg,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: jwtCookie,
        },
      }
    );
    return response.data;

  } catch (error) {
    console.error("Error:", error.response?.data?.message || error.message);
    throw error;
  }
};

export { sendMessageDB };